import React from 'react'
// import epcclogo from '../images/epcc/eppcc_logo.png';
// import epcclogo2x from '../images/epcc/eppcc_logo@2x.png';

// import epccinstall from '../images/epcc/epcc_install_image.png';
// import epccinstall2x from '../images/epcc/epcc_install_image@2x.png';
// import exstr from '../images/epcc/excellent_strength.svg';
import epccimg from '../images/epcc/epcc_image_big.png';
import remarkico from '../images/epcc/ready_to_use.svg';
import lgt from '../images/epcc/lightweight.svg';
import zerosc from '../images/epcc/zero_scrap_value.svg';
import pplay from '../images/epcc/plug_and_play.svg';
import env from '../images/epcc/environmentally.svg';
import exp from '../images/epcc/exceptional.svg';
import ruse from '../images/epcc/ready_to_use.svg';
import hfree from '../images/epcc/hassle_free.svg';
import extlife from '../images/epcc/extended_lifespan.svg';
import nomain from '../images/epcc/no_maintenance.svg';
import uv from '../images/epcc/uv_stabilized.svg';
import Image from 'next/image';

const Epccdetailscontent = () => {
    const eppc = "https://raw.githubusercontent.com/gobisn/Images/main/epcc_install_image.png";
    const eppc2x = "https://raw.githubusercontent.com/gobisn/Images/main/epcc_install_image%402x.png";
    return (
        <>
            <div className=' w-full flex-col mx-auto flex mt-3 justify-center items-center'>
                <div className='container max-w-screen-xl mx-auto flex flex-col justify-center items-center px-4 lg:px-0'>
                    <div className='flex items-center justify-center flex-col mt-5'>
                        {/*
                    <Image className='m-2' src={epcclogo}
                        srcSet={` ${epcclogo} 1x, ${epcclogo2x} 2x`}
      alt="epclogo"/> */}
                        <Image src={epccimg}
                            priority
                            style={{'objectFit':'contain'}}
                            width={1266}
                            height={803}
                            alt="Earth Pit Chamber Cover with Ashlok Safe Earthing Electrode Limited" />

                    </div>

                    <div className='mt-5 px-2 lg:px-0'>
                        <h1 className='text-xl lg:text-2xl  text-ashred'><span className='vollkorn-sc-semibold'> EarthPit Chamber Cover(<span style={{ fontSize: '80%' }}>s</span>)</span></h1>
                        <p className=' text-base text-justify'> An initiative under the aegis of <span className='vollkorn-sc-semibold'>Ashlok</span>, the assortment of Earth Pit Chamber Covers is meticulously crafted with the user’s convenience in mind. Simultaneously, great consideration is given to the contemporary impact on the environment, either directly or indirectly, by adopting raw materials that not only enhance the value of the EPCC series but also ensure ecological well-being, harmoniously coexisting. The fundamental constituents comprise a precise blend of High-Density PolyEthylene (HDPE) compounds, fortified with glass fibers, along with additives like antioxidants and proprietary elements. These elements synergistically yield a high-tensile, quality product endowed with numerous attributes. This renders the Earth Pit Chamber Cover an auxiliary guardian to the overall Lightning and Earthing Solution implemented in your premises, providing the ultimate protection.</p>
                        <p className=' text-base text-justify'> The fundamental constituents comprise a precise blend of High-Density PolyEthylene (HDPE) compounds, fortified with glass fibers, along with additives like antioxidants and proprietary elements. These elements synergistically yield a high-tensile, quality product endowed with numerous attributes. This renders the Earth Pit Chamber Cover an auxiliary guardian to the overall Lightning and Earthing Solution implemented in your premises, providing the ultimate protection.
                        </p>

                    </div>
                </div>


           


                <div className='w-full flex justify-center items-center mt-3 bg-ashgray1  '>
                    <div className='container mx-auto max-w-screen-xl flex flex-col justify-center my-3 px-4 lg:px-0'>
                        <div className='flex  flex-col lg:flex-row  lg:space-x-10'>
                            <div className=' w-full lg:w-1/2 mx-3 lg:mx-0'>
                                <p className=' text-1xl  text-ashred font-semibold'>Features & Benefits</p>
                                <ul className="list-none">
                                    <li className="flex items-center "><Image src={remarkico} className="mr-2 pr-2 my-2" alt="ashlok epcc Remarkable tensile strength" />Remarkable tensile strength</li>
                                    <li className="flex items-center"><Image src={lgt} className="mr-1.5 pr-1.5 my-2" alt="ashlok epcc Lightweight" />Lightweight - Facilitates easy handling and transportation</li>
                                    <li className="flex items-center"><Image src={extlife} className="mr-2 pr-2 my-2" alt="ashlok epcc Excellent strength" />Excellent strength-to-weight ratio</li>
                                    <li className="flex items-center"><Image src={zerosc} className="mr-2 pr-2 my-2" alt="ashlok epcc Zero Scrap Value" />Zero Scrap Value - Acts as a theft deterrent</li>
                                    <li className="flex items-center"><Image src={pplay} className="mr-2 pr-2 my-2" alt="ashlok Plug and Play" />Plug and Play configuration - Install and forget</li>
                                    <li className="flex items-center"><Image src={env} className="mr-2 pr-2 my-2" alt="ashlok Environmentally friendly" />Environmentally friendly</li>
                                </ul>
                            </div>
                            <div className='w-full lg:w-1/2'>

                                <ul className="list-none">
                                    <li className="flex items-center"></li>
                                    <li className=" items-center text-ashgray1 hidden lg:block  "><p src={exp} className="mr-2 pr-2 m-3  text-ashgray1" />Exceptional compressive strength</li>
                                    <li className="flex items-center"><Image src={exp} className="mr-2 pr-2 m-3" alt="ashlok epcc  Exceptional compressive strength" />Exceptional compressive strength</li>
                                    <li className="flex items-center"><Image src={ruse} className="mr-2 pr-2 mx-3" alt="ashlok epcc  Ready to use" />Ready to use - No curing time required</li>
                                    <li className="flex items-center"><Image src={hfree} className="mr-2 pr-2 mx-3 my-3" alt="ashlok epcc  Hassle-Free Installation" />Hassle-Free Installation</li>
                                    <li className="flex items-center"><Image src={extlife} className="mr-2 pr-2 mx-3 my-2" alt="ashlok epcc  Extended lifespan" />Extended lifespan</li>
                                    <li className="flex items-center"><Image src={nomain} className="mr-2 pr-2 mx-3 my-2" alt="ashlok epcc No maintenance required" />No maintenance required - Install and forget</li>
                                    <li className="flex items-center"><Image src={uv} className="mr-2 pr-2 mx-3 my-3" alt="ashlok epcc UV Stabilized" />UV Stabilized</li>
                                </ul>
                            </div>
                            <div className='w-1/4'></div>

                        </div>
                    </div>
                </div>
                <div className=' w-full flex-col mx-auto flex my-3 justify-center items-center'>
                <div className='container max-w-screen-xl mx-auto flex flex-col justify-center items-center px-4 lg:px-0'>
                    <div className='flex justify-center flex-col'>
                                <h2 className=' text-2xl'><span className="vollkorn-sc-semibold">Ashlok</span> Earth Pit Chamber Cover – Durable Solution for Secure Grounding
                                Installations</h2>
                                <p className=' text-base text-justify'>The <span className="vollkorn-sc-semibold">Ashlok</span> Earth Pit Chamber Cover is designed to provide secure protection for
earth pit chambers and inspection chambers. Made from high-quality materials, it
ensures durability and easy access for maintenance. Ideal for covering earth
chambers, this pit cover safeguards grounding systems while maintaining longlasting
performance in all conditions. Choose Ashlok for reliable solutions to
protect your earth pit chamber installations</p>
                    </div>
                    </div>
                    </div>
                {/*
            <div className='container w-max-xl mx-auto flex flex-col justify-center items-center my-3'>
                <div className='flex justify-center items-center'>
                    <Image src={eppc}
                    srcSet={`${eppc} 1x, ${eppc2x} 2x `}
                    alt="epcc install"/>
                </div>
                </div>
            */}
                {/* hide content */}
                    <div>
                        <p className="sr-only">earth pit chamber cover</p>
                        <p className="sr-only">earth chamber cover</p>
                        <p className="sr-only">earthing pit cover</p>
                  
                    </div>

            </div>
        </>
    )
}

export default Epccdetailscontent
